var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    title: "Volume off",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0H8V2H6V4H4V6H2H0V8V12V14H2H4V16H6V18H8V20H10V0ZM6 16V14H4V12H2V8H4V6H6V4H8V16H6ZM16.0002 9.22327H14.0005V7.22327H12.0005V9.22327H14.0002V11.2233L12.0005 11.2233V13.2233H14.0005V11.2233L16.0002 11.2233V13.2233H18.0002V11.2233L16.0002 11.2233V9.22327ZM16.0002 9.22327H18.0002V7.22327H16.0002V9.22327Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/volumeOff.31e67237590f44f4b5052370c613f23c.svg";
export { ForwardRef as ReactComponent };